var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartContractSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1429_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7536 62.3274H11.2478C10.6892 62.3274 10.2363 61.8749 10.2363 61.3159V42.0974C10.2363 41.5383 10.6892 41.0859 11.2478 41.0859H55.7536C56.3122 41.0859 56.7651 41.5383 56.7651 42.0974V61.3159C56.7651 61.8749 56.3122 62.3274 55.7536 62.3274Z",
    fill: "url(#paint0_linear_1429_5179)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1429_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 67H1.45652C0.652158 67 0 66.3486 0 65.5435V37.8696C0 37.0645 0.652158 36.4131 1.45652 36.4131H65.5435C66.3478 36.4131 67 37.0645 67 37.8696V65.5435C67 66.3486 66.3478 67 65.5435 67Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 67H1.45652C0.652158 67 0 66.3486 0 65.5435V37.8696C0 37.0645 0.652158 36.4131 1.45652 36.4131H65.5435C66.3478 36.4131 67 37.0645 67 37.8696V65.5435C67 66.3486 66.3478 67 65.5435 67Z",
    fill: "url(#paint1_linear_1429_5179)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5435 66.4H1.45652C0.98334 66.4 0.6 66.017 0.6 65.5435V37.8696C0.6 37.3961 0.983341 37.0131 1.45652 37.0131H65.5435C66.0167 37.0131 66.4 37.3961 66.4 37.8696V65.5435C66.4 66.017 66.0167 66.4 65.5435 66.4Z",
    stroke: "url(#paint2_linear_1429_5179)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1429_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3488 48.0654H32.0444C31.24 48.0654 30.5879 47.4139 30.5879 46.6089C30.5879 45.8038 31.24 45.1523 32.0444 45.1523H55.3488C56.1531 45.1523 56.8053 45.8038 56.8053 46.6089C56.8053 47.4139 56.1531 48.0654 55.3488 48.0654Z",
    fill: "white",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1429_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3475 58.2607H11.6518C10.8475 58.2607 10.1953 57.6092 10.1953 56.8042C10.1953 55.9991 10.8475 55.3477 11.6518 55.3477H55.3475C56.1519 55.3477 56.804 55.9991 56.804 56.8042C56.804 57.6092 56.1519 58.2607 55.3475 58.2607Z",
    fill: "white",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.7241 19.2274L42.898 13.4013C42.329 12.8324 41.4073 12.8324 40.8384 13.4013L13.5351 40.7048C11.7195 42.5204 11.4422 45.2779 12.659 47.407L10.622 49.444C10.0531 50.0129 10.0531 50.9346 10.622 51.5036C10.9065 51.788 11.2792 51.9303 11.6518 51.9303C12.0245 51.9303 12.3972 51.788 12.6816 51.5036L14.7184 49.4668C15.5727 49.9551 16.5208 50.2213 17.4779 50.2213C18.906 50.2213 20.3341 49.6779 21.4208 48.5905L48.7241 21.287C49.293 20.7181 49.293 19.7964 48.7241 19.2274Z",
    fill: "url(#paint3_linear_1429_5179)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.978 32.9953C50.6053 32.9953 50.2327 32.8531 49.9482 32.5686C49.3792 31.9997 49.3792 31.0779 49.9482 30.509L60.5706 19.8866L57.2308 16.5469C56.6619 15.9779 56.6619 15.0562 57.2308 14.4873C57.7997 13.9183 58.7215 13.9183 59.2904 14.4873L63.66 18.8568C64.2289 19.4258 64.2289 20.3475 63.66 20.9164L52.0078 32.5686C51.7233 32.8531 51.3507 32.9953 50.978 32.9953Z",
    fill: "url(#paint4_linear_1429_5179)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_1429_5179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2906 2.83552C55.5099 -0.945174 49.3595 -0.945174 45.5788 2.83552L28.1005 20.3138C27.5316 20.8827 27.5316 21.8044 28.1005 22.3734L39.7527 34.0256C40.0372 34.31 40.4099 34.4523 40.7825 34.4523C41.1552 34.4523 41.5278 34.31 41.8123 34.0256L59.2906 16.5473C63.0713 12.7673 63.0713 6.6155 59.2906 2.83552Z",
    fill: "#F1F1F1",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2906 2.83552C55.5099 -0.945174 49.3595 -0.945174 45.5788 2.83552L28.1005 20.3138C27.5316 20.8827 27.5316 21.8044 28.1005 22.3734L39.7527 34.0256C40.0372 34.31 40.4099 34.4523 40.7825 34.4523C41.1552 34.4523 41.5278 34.31 41.8123 34.0256L59.2906 16.5473C63.0713 12.7673 63.0713 6.6155 59.2906 2.83552Z",
    fill: "url(#paint5_linear_1429_5179)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8663 3.25978L58.8664 3.25982C62.4127 6.80548 62.4127 12.5773 58.8664 16.123L58.8663 16.123L41.3881 33.6013C41.2205 33.7688 41.0024 33.8523 40.7825 33.8523C40.5626 33.8523 40.3445 33.7688 40.177 33.6013L28.5248 21.9491C28.1902 21.6145 28.1902 21.0727 28.5248 20.738L46.0031 3.25978C49.5494 -0.286595 55.3199 -0.286595 58.8663 3.25978Z",
    stroke: "url(#paint6_linear_1429_5179)",
    strokeOpacity: 0.1,
    strokeWidth: 1.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1429_5179",
    x: -24,
    y: 12.4131,
    width: 115,
    height: 78.5869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5179",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5179"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1429_5179",
    x: 30.5879,
    y: 45.1523,
    width: 26.2178,
    height: 10.9131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5179"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1429_5179",
    x: 10.1953,
    y: 55.3477,
    width: 46.6084,
    height: 10.9131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1429_5179"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bi_1429_5179",
    x: 3.67383,
    y: -24,
    width: 82.4521,
    height: 82.4521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1429_5179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1429_5179",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1429_5179"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_5179",
    x1: 12.175,
    y1: 45.3342,
    x2: 59.494,
    y2: 59.7302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_5179",
    x1: 2.79167,
    y1: 42.5305,
    x2: 70.9294,
    y2: 63.2602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1429_5179",
    x1: 2.09375,
    y1: 37.8034,
    x2: 67,
    y2: 37.8034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1429_5179",
    x1: 11.8185,
    y1: 20.7658,
    x2: 54.2832,
    y2: 26.6636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1429_5179",
    x1: 50.1284,
    y1: 17.8475,
    x2: 66.1293,
    y2: 19.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AE6CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1429_5179",
    x1: 29.1093,
    y1: 6.89046,
    x2: 66.6652,
    y2: 12.1065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8940FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1429_5179",
    x1: 28.7505,
    y1: 1.56601,
    x2: 62.1261,
    y2: 1.56601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1429_5179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContractSignature);
export default __webpack_public_path__ + "static/media/smart-contract_signature.2df35619f0973645c7b2cf576a671e51.svg";
export { ForwardRef as ReactComponent };